export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewDeliveryMethod(state, { payload }) {
    state.delivery_methods = [...state.delivery_methods, ...[payload]];
  },

  delProperty(state, { property }) {
    state.delivery_methods = state.delivery_methods.filter(el => el.id !== property);
  },
};
